"use client";

import { createContext, useContext } from "react";

export const GoogleOAuthReadyContext = createContext<boolean>(false);

export const useGoogleOAuthReady = () => useContext(GoogleOAuthReadyContext);
